module.exports = __webpack_public_path__ + "assets/img/Chama-Landing-Page-+-Website.b918c791.jpg";